import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton } from "@mui/material";
import { TitleSubTitle } from "@platformx/utilities";
import { useEffect, useState } from "react";
import SelectPageList from "./SelectPageList";

const PagePicker = ({ state, setState, field }) => {
  const [openPage, setOpenPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState<any>(null);

  const onSelectPage = (page) => {
    setSelectedPage(page);
  };

  const handleBackPage = () => {
    setOpenPage(false);
    setSelectedPage(state?.[field.name] || null);
  };

  const onClickPageDone = () => {
    setOpenPage(false);
    setState({
      ...state,
      [field.name]: selectedPage,
    });
  };

  const onOpenPage = () => {
    setOpenPage(true);
  };

  const onClearPage = () => {
    setSelectedPage(null);
    setState({
      ...state,
      [field.name]: "",
    });
  };

  useEffect(() => {
    const value = state?.[field.name];
    // Only a real page object is a valid selection. Guard against the empty
    // string / empty array that RadioCustomOptions re-seeds dependent fields
    // with on a radio switch, which otherwise renders an empty (title-less) box.
    if (value && typeof value === "object" && !Array.isArray(value)) {
      setSelectedPage(value);
    } else {
      setSelectedPage(null);
    }
  }, [state, field.name]);

  return (
    <>
      <Button variant='primaryButton' onClick={onOpenPage}>
        {field?.placeholder}
      </Button>

      {selectedPage ? (
        <Box
          className='category-container'
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "solid 1px #ced3d9",
            borderRadius: "5px",
            padding: "13px 14px",
            width: "100%",
            marginTop: "12px",
          }}>
          <Box>
            <TitleSubTitle
              title={selectedPage?.Title}
              subTitle=''
              titleVariant='p4regular'
              subTitleVariant='h6regular'
            />
          </Box>
          <IconButton
            onClick={onClearPage}
            data-testid='clear-page'
            sx={{ width: "32px", height: "32px" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      ) : null}

      {openPage ? (
        <SelectPageList
          handleBack={handleBackPage}
          selectedPage={selectedPage}
          onClickDone={onClickPageDone}
          onSelectPage={onSelectPage}
        />
      ) : null}
    </>
  );
};

export default PagePicker;
